import { render } from "./RequestTable.vue?vue&type=template&id=4e62775e&scoped=true"
import script from "./RequestTable.vue?vue&type=script&lang=js"
export * from "./RequestTable.vue?vue&type=script&lang=js"

import "./RequestTable.vue?vue&type=style&index=0&id=4e62775e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e62775e"]])

export default __exports__